import React from 'react'
import MEModal from '../../components/MEModal'
import { Button } from '@CommonComponents/buttons'
import { useStateValue } from '@State'
import { removeCourseMember } from '../actions'
import { toast } from '@CommonComponents/toast'

export const removeCourseMemberItem = {
  id: 'remove-member',
  label: 'Remove',
  icon: 'fa-light fa-minus-circle',
  danger: true,
}

export const RemoveCourseMemberModal = ({
  user_id,
  user_full_name,
  show,
  close,
}) => {
  const [currentState, dispatch] = useStateValue()

  const submitRemoveCourseMember = async () => {
    close()
    let data = { ...currentState.filters }
    data.user_id = user_id
    data.archivedPageNum = currentState.currentArchivePage
    data.pageNum = currentState.currentCourseMemPage

    let response = await removeCourseMember(data, dispatch)
    if (response.status === 200) {
      toast.info("Successfully removed from course.")
    } else {
      toast.error(response.message)
    }
  }

  return (
    <MEModal show={show} close={close} title="Remove From Course">
      <form onSubmit={e => e.preventDefault()}>
        <p>
          Are you sure you want to remove <i>{user_full_name}</i>{' '}
          from this course?
        </p>
        <Button
          className="mt-3 me-btn me-btn-danger"
          type="button"
          onClick={submitRemoveCourseMember}
        >
          Remove from course
        </Button>
      </form>
    </MEModal>
  )
}
